import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { getBootstrap } from './lib/api'
import { router } from './router'
import './styles.css'

const data = getBootstrap()

// Some pages are documents, not applications: the company directory, a company
// page, a monthly report, the status page. The server has already rendered
// everything they state, and there is no interaction on them that a link cannot
// do — so React never mounts, and the crawler and the reader are guaranteed the
// same document rather than merely a similar one. The theme control keeps
// working; it is driven by the inline script in the document head.
if (!(data as { ssrOnly?: boolean }).ssrOnly) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}
